import {SelectCardToDiscardFormat} from '@colonist/game-card-types'
import {GameColor} from '../../../../shared/scripts/GameColor'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameCardContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardContainerView'
import {UIGamePopupConfirmationButtons} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupConfirmationButtons'
import {UIGamePopupDiscardCards} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupDiscardCards'
import {MechanicProgressCardsState} from '@colonist/game-states'

export class UIMGamePopupDiscardCards extends UIGamePopupDiscardCards {
    constructor(uiGameManager: UIGameManager, selectCardFormat: SelectCardToDiscardFormat, progressCardsState: MechanicProgressCardsState | undefined) {
        const canvas = uiGameManager.canvasController
        const selectedCardsH = canvas.itemSize * 1.2
        super(uiGameManager, selectCardFormat, selectedCardsH, progressCardsState)
    }

    protected createConfirmationButtons() {
        const clickedCheckAction = () => {
            this.checkAction()
        }
        const clickedCancelAction = () => undefined
        const canvas = this.uiGameManager.canvasController
        const w = canvas.popupWidth
        const buttonH = canvas.itemSize
        const buttonY = this.absoluteHeight
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, buttonY, w, buttonH, clickedCheckAction, clickedCancelAction, this, false)
    }

    protected setContainerY() {
        const canvas = this.uiGameManager.canvasController
        const spaceFromBottom = canvas.bottomViewHeight
        this.y = canvas.appH - spaceFromBottom - this.absoluteHeight
    }

    protected createPlayerCardContainerView() {
        const canvas = this.uiGameManager.canvasController
        const playerCardContainerX = 0
        const playerCardContainerH = canvas.itemSize * 1.2
        const playerCardContainerY = canvas.appH - canvas.bottomViewHeight - this.y
        const playerCardContainerW = UIUtilsEjsVariables.isUserOnTabletApp ? canvas.appW / 2 : canvas.appW

        this.playerCardContainer = new UIGameCardContainerView(this.uiGameManager, playerCardContainerX, playerCardContainerY, playerCardContainerW, playerCardContainerH, this, false, false)
        this.playerCardContainer.drawBg(GameColor.getColorHexValue(GameColor.Color.PrimaryBlue6), 1)
    }
}
